import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-038c5b79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-gray-07" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "事業所詳細", -1))
const _hoisted_3 = { class: "bg-white border-bottom border-gray-03" }
const _hoisted_4 = {
  class: "pt-3 px-3",
  ref: "orderList"
}
const _hoisted_5 = { class: "order-list-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-500 text-mild" }, "お仕事一覧", -1))
const _hoisted_7 = {
  key: 0,
  class: "order-list"
}
const _hoisted_8 = {
  key: 1,
  class: "px-3 py-3"
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14 text-mild pt-4 text-center" }, "\n              お仕事がありません\n            ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppStoreBanner = _resolveComponent("AppStoreBanner")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_OfficeInformation = _resolveComponent("OfficeInformation")!
  const _component_HiringOnlyOrderButton = _resolveComponent("HiringOnlyOrderButton")!
  const _component_SimpleOrderListItem = _resolveComponent("SimpleOrderListItem")!
  const _component_Balloon = _resolveComponent("Balloon")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_OfficeMuteModal = _resolveComponent("OfficeMuteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppStoreBanner, {
      shouldShown: _ctx.shouldShownAppStoreBanner,
      onClose: _ctx.closeAppStoreBanner
    }, null, 8, ["shouldShown", "onClose"]),
    _createTextVNode(),
    _createElementVNode("div", {
      class: _normalizeClass(["pb-2", _ctx.shouldShownAppStoreBanner ? 'app-store-banner-space' : null])
    }, [
      _createVNode(_component_Header, null, {
        left: _withCtx(() => [
          _createVNode(_component_FeatherIcon, {
            icon: "chevron-left",
            onClick: _ctx.goBack
          }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createTextVNode(),
          _hoisted_2
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_OfficeInformation, {
          office: _ctx.office,
          officeServiceName: _ctx.officeServiceName,
          evaluationTotalAverage: _ctx.evaluationTotalAverage,
          evaluationCount: _ctx.evaluationCount,
          mostFrequentOrderTemplate: _ctx.mostFrequentOrderTemplate,
          isFavorite: _ctx.isFavorite,
          isMutedOffice: _ctx.isMutedOffice,
          onFavoriteChange: _ctx.updateFavoriteOffice,
          onChangeMutedOffice: _ctx.onClickMuteButton
        }, null, 8, ["office", "officeServiceName", "evaluationTotalAverage", "evaluationCount", "mostFrequentOrderTemplate", "isFavorite", "isMutedOffice", "onFavoriteChange", "onChangeMutedOffice"])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createTextVNode(),
          _createVNode(_component_HiringOnlyOrderButton, {
            hiringOnly: _ctx.hiringOnly,
            onToggleHiringOnly: _ctx.toggleHiringOnly
          }, null, 8, ["hiringOnly", "onToggleHiringOnly"])
        ]),
        _createTextVNode(),
        (_ctx.isLoading || _ctx.hasOrderList)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                return (_openBlock(), _createBlock(_component_SimpleOrderListItem, {
                  order: order,
                  key: order.id,
                  class: "d-block"
                }, null, 8, ["order"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Balloon)
              ]),
              _createTextVNode(),
              _hoisted_10
            ]))
      ], 512)
    ], 2),
    _createTextVNode(),
    _createVNode(_component_AppFooter),
    _createTextVNode(),
    _createVNode(_component_OfficeMuteModal, {
      isShown: _ctx.isShownMutedOfficeModal,
      officeName: _ctx.office?.name,
      onSubmit: _ctx.onSubmitMuteOfficeModal,
      onCancel: _ctx.onCloseMuteOfficeModal
    }, null, 8, ["isShown", "officeName", "onSubmit", "onCancel"])
  ]))
}